export const SCIENCES = ['BIO', 'CH', 'PH', 'M', 'm', 'ch', 'ph', 'bio'];
export const NW = ['BIO', 'CH', 'PH', 'ch', 'ph', 'bio'];
export const NWMAIN = ['BIO', 'CH', 'PH'];
export const LANGSBASIC = ['l(5)', 'e', 'f', 'd'];
export const INFORMATICS = ['DE', 'E', 'f', 'l(5)', 'inf'];
export const NODMA = ['DE', 'M'];
export const FOREIGNLANG = ['e', 'f'];

export const NOSPORTLANGSMAIN = ['DE', 'E', 'SP'];
export const NOSPORTLANGSBASIC = ['d', 'e', 'SP'];
export const NOSPORTSCIENCES = ['BIO', 'CH', 'PH', 'M', 'SP'];
export const SPORTBASIC = ['ge+ek/sk', 'd', 'e'];
export const SPORTBASICNW = ['ge+ek/sk', 'm', 'ch', 'ph', 'bio'];
export const SPORTMAIN = ['ge+ek/sk', 'DE', 'E'];

export const isScience = (c) => SCIENCES.includes(c);
export const isNW = (c) => NW.includes(c);
export const isNWMain = (c) => NWMAIN.includes(c);
export const isLanguageBasic = (c) => LANGSBASIC.includes(c);
export const isInformatics = (c) => INFORMATICS.includes(c);
export const isNoDMa = (c) => NODMA.includes(c);
export const isForeignLang = (c) => FOREIGNLANG.includes(c);

export const isNoSportLangsMain = (c) => NOSPORTLANGSMAIN.includes(c);
export const isNoSportLangsBasic = (c) => NOSPORTLANGSBASIC.includes(c);
export const isNoSportScience = (c) => NOSPORTSCIENCES.includes(c);
export const isSportBasic = (c) => SPORTBASIC.includes(c);
export const isSportBasicNW = (c) => SPORTBASICNW.includes(c);
export const isSportMain = (c) => SPORTMAIN.includes(c);